declare const economicCalendar: any;

export class EconomicCalendarComponent {
    $onInit() {
        new economicCalendar({ width: '100%', height: '535px', mode: 2 });
    }
}

angular.module('tradersyard').component('tyEconomicCalendarComponent', {
    // language=HTML
    template: `
        <div id="economicCalendarWidget"></div>
    `,
    controller: EconomicCalendarComponent,
});
